import * as React from 'react';
import { fromArrayToString } from '../../../utils/from-array-to-string.js';
import '@grandvisionhq/graphql';
import '@swc/helpers';
import { useAppointmentContext } from '../context/AppointmentContext.js';
import { useRoutingContext } from '../context/RoutingContext/context.js';
import useBookAppointmentStoreById from './api/use-book-appointment-store-by-id.js';
import '@grandvisionhq/state';
import '../queries/get-book-appointment-type.js';
import '../queries/get-book-appointment-store-by-id.js';
import useVirtualAppointment from './use-virtual-appointment.js';

const useBookAppointmentStoreWithUrlParam = ()=>{
    const [, { queryParams  }] = useRoutingContext();
    const filterWithGroupId = fromArrayToString(queryParams.groupId);
    const [getBookAppointmentStore, { called , data , loading , error  }] = useBookAppointmentStoreById({
        isGroupIdEnabled: fromArrayToString(queryParams.groupId) === filterWithGroupId ? filterWithGroupId : null
    });
    const [{ setStore  }, { store  }] = useAppointmentContext();
    const [{ getAppointmentTypeData , getStoreByIdData  }, { globalStoreId: virtualStoreId  }] = useVirtualAppointment();
    React.useEffect(()=>{
        if (error) {
            console.error(error);
            return;
        }
        const { storeId: storeIdFromUrl  } = queryParams;
        const storeId = fromArrayToString(storeIdFromUrl);
        if (loading || !storeId || storeId === (store === null || store === void 0 ? void 0 : store.globalStoreId)) {
            return;
        }
        const isVirtualAppointmentStoreId = storeId === virtualStoreId;
        if (isVirtualAppointmentStoreId) {
            setStore(getStoreByIdData(undefined, getAppointmentTypeData()));
            return;
        }
        getBookAppointmentStore(storeId);
    }, [
        queryParams,
        store,
        loading,
        error,
        virtualStoreId,
        setStore,
        getStoreByIdData,
        getAppointmentTypeData,
        getBookAppointmentStore, 
    ]);
    React.useEffect(()=>{
        if (!called || !data || loading) {
            return;
        }
        setStore(data);
    }, [
        called,
        data,
        loading,
        setStore
    ]);
};

export { useBookAppointmentStoreWithUrlParam as default };
//# sourceMappingURL=use-book-appointment-store-with-url-param.js.map
